<template>
  <div class="header">
    <div @click="goHomePage">
      <img :src="require(`../assets/image/${getLogoName}.png`)" />
    </div>
    <div v-show="routerPath !== '/login'">
      <div>
        <span>哈囉，{{ user.name }}{{ title }}（</span>
        <span class="logout" @click="logout">登出</span>
        <span>）</span>
      </div>
      <div
        class="online"
        v-tooltip.bottom="{ content: getOnlineTooltip(), html: true }"
      >
        線上人數：{{ onlineData.number }} 位
      </div>
      <div>
        <div v-if="!user.id.includes('AW')" @click="goChatroom">
          <font-awesome-icon icon="comments" />
        </div>

        <div @click="$router.push('/alumni')">
          <font-awesome-icon icon="graduation-cap" />
        </div>
        <div @click="showNoticeBoard">
          <font-awesome-icon icon="bell" />
        </div>
        <div
          v-if="user.id.includes('SW')"
          @click="$router.push('/personal')"
        >
          <div class="notice" v-if="isCommitment === false">
            <font-awesome-icon icon="circle-exclamation" />
          </div>
          <font-awesome-icon icon="user" />
        </div>
      </div>
      <div class="version">
        {{ version }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import pkg from '../../package.json';

export default {
  name: 'Header',
  data() {
    return {
      routerPath: this.$router.history.current.path,
      version: pkg.version,
    };
  },
  computed: {
    ...mapState('common', ['user', 'isCommitment', 'onlineData']),
    getLogoName() {
      if (this.$isMobile() && this.routerPath !== '/login') return 'smallLogo';
      return 'logo';
    },
    title() {
      let title;
      const role = this.user.id.slice(0, 2);
      switch (role) {
        case 'SW':
          title = '學生';
          break;
        case 'TW':
          title = '老師';
          break;
        case 'AW':
          title = '管理者';
          break;
        default:
      }
      return title;
    },
  },
  watch: {
    $route(to) {
      this.routerPath = to.path;
    },
  },
  methods: {
    async logout() {
      try {
        this.$cookies.remove('CWLUser');
        this.$cookies.remove('isShowNoticeboard');
        this.$router.go('/login');
      } catch {
        // console.log(err);
      }
    },
    goHomePage() {
      let url;
      const role = this.user.id.slice(0, 2);

      switch (role) {
        case 'SW':
          url = '/';
          break;
        case 'TW':
          url = '/classesAndQuestions';
          break;
        case 'AW':
          url = '/admin';
          break;
        default:
      }
      this.$router.push(url);
    },
    goChatroom() {
      const routeData = this.$router.resolve(
        {
          path: '/chatroom',
        },
      );
      window.open(routeData.href, '_blank');
    },
    showNoticeBoard() {
      this.$store.commit('common/SET_NOTICEBOARD_STATUS', true);
    },
    getOnlineTooltip() {
      if (!this.user.id.includes('SW') && this.onlineData.list) {
        return this.onlineData.list
          .map((i) => `<div class="tooltip">
              <div class="tooltip-id">${i.cw_id}</div>
              <div class="tooltip-name">${i.codingwizard_info.name}</div>
              <div class="tooltip-school">${i.codingwizard_info.university || i.codingwizard_info.senior || i.codingwizard_info.junior || i.codingwizard_info.elementary || i.codingwizard_info.job || '未知'}</div>
              <div class="tooltip-time">${dayjs(i.login_time).format('HH:mm:ss')}</div>
            </div>`).join('');
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100vw;
  padding: 20px 25px 0;
  z-index: 100;
  background: $main-yellow;

  > div {
    &:first-child {
      cursor: pointer;

      img {
        height: 42px;
        width: auto;
      }
    }

    &:nth-child(2) {
      display: flex;
      align-items: center;

      > div {
        &:nth-child(3) {
          display: flex;

          > div {
            width: 28px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            background: $main-purple;
            color: $main-yellow;
            border-radius: 50%;
            margin-left: 10px;
            cursor: pointer;
            position: relative;

            .notice {
              position: absolute;
              top: -12px;
              left: -6px;
              color: red;
            }
          }
        }
      }

      .logout {
        cursor: pointer;
        color: $main-purple;
      }

      .online {
        margin-left: 10px;
      }

      .version {
        margin-left: 10px;
      }
    }
  }
}
</style>
